export const infoOfPharmacy = [
  {
    label: 'pharmacy',
    type: 'text',
    name: 'name',
    validation: 'required',
    dataTestId: 'inputPharmacyName'
  },
  {
    label: 'pharmacyEntryPin',
    type: 'text',
    name: 'pinCode',
    dataTestId: 'inputPharmacyPinCode'
  },
  {
    label: 'address',
    type: 'text',
    name: 'streetAddress',
    dataTestId: 'inputPharmacyStreetAddress'
  }
];

export const infoPhoneNumber = [
  {
    label: 'alarmPhoneNumber',
    type: 'tel',
    dataTestId: 'inputPharmacyAlarmPhoneNumber',
    name: 'phoneNumber',
    validation: [['required'], ['matches', /^\+[0-9]{10,14}$/]],
    validationVisibility: 'dirty'
  }
];

export const infoEmail = [
  {
    label: 'alarmEmail',
    type: 'email',
    name: 'email',
    validation: 'required|email',
    dataTestId: 'inputPharmacyAlarmEmail'
  }
];

export const infoOfDeliveries = [
  {
    label: 'deliveryExpirationTime',
    type: 'text',
    name: 'deliveryKeepTime',
    dataTestId: 'inputDeliveryKeepTime'
  },
  {
    label: 'reminderMessageTime',
    type: 'text',
    name: 'deliveryReminderMessagePeriod',
    dataTestId: 'inputDeliveryReminderMessagePeriod'
  }
];

export const formDataDefault = {
  name: '',
  email: '',
  additionalEmails: {},
  pickupBox: {
    customerSMSLanguages: '',
    customerSMSLanguage: ''
  },
  serviceLanguages: '',
  customersPhoneNumber: '',
  phoneNumber: '',
  additionalPhoneNumbers: {},
  serviceRequest: false,
  description: '',
  showToCustomers: false,
  sendNewCallbackRequestEmailNotification: false,
  services: {
    pickupbox: false,
    homeDelivery: false,
    pharmacyPickup: false
  },
  workingHours: {
    mon: { closed: true, from: '', to: '' },
    tue: { closed: true, from: '', to: '' },
    wed: { closed: true, from: '', to: '' },
    thu: { closed: true, from: '', to: '' },
    fri: { closed: true, from: '', to: '' },
    sat: { closed: true, from: '', to: '' },
    sun: { closed: true, from: '', to: '' }
  }
};
